import Container from './SubscriptionCenterBox.container';
import SubscriptionCenterBox from './SubscriptionCenterBox';

export default Container(SubscriptionCenterBox);
